export default __webpack_public_path__ + "static/media/teeth - active_v1.cdd3cf64.svg";